import { ITEM_TYPES } from './ItemTypes';
var MULTILINGUAL_TYPES = [
    ITEM_TYPES.BLOG_POST,
    ITEM_TYPES.BLOG_CATEGORY,
    ITEM_TYPES.STORES_PRODUCT,
    ITEM_TYPES.CHALLENGES_PAGE,
    ITEM_TYPES.EVENTS_PAGE,
    ITEM_TYPES.STATIC_PAGE,
    ITEM_TYPES.STATIC_PAGE_V2,
];
export var isMultilingualType = function (type) { return MULTILINGUAL_TYPES.includes(type); };
var NON_MULTILINGUAL_STATIC_PAGES = [
    'menu',
];
export var skipMultilingualForTpaPageId = function (type, tpaPageId) {
    return type === ITEM_TYPES.STATIC_PAGE_V2 &&
        NON_MULTILINGUAL_STATIC_PAGES.includes(tpaPageId);
};
